import DEFAULT_SWITCH_CLASS_NAME from '../../constants/switch';

export const defaultSwitch = ({ theme }) => ({
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
});

const MuiSwitch = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${DEFAULT_SWITCH_CLASS_NAME}`]: defaultSwitch({ theme }),
    }),
  },
};

export default MuiSwitch;
